export enum RouterCommonPagesEnum {
  Settings = 'settings',
  UserActivity = 'user-activity',
  ExampleSum = 'example-sum',
  ContentPlayerTestPage = 'content-player-test',
}
